// Primary 5 Chinese Data - Part 1
// Based on Primary Chinese P5 Topics.txt

export const p5DataPart1 = {
  title: "小學五年級中文學習",
  description: "專為小學五年級學生設計的中文學習內容，進一步提升語文能力和寫作技巧",
  objectives: "提升語文運用能力，培養寫作思維，掌握更複雜的語法結構",
  focus: "重點學習反義詞、多重複句、肯定句和否定句等進階語法，以及更豐富的文體閱讀理解",
  
  readingTypes: [
    "說明事物", "歷史故事", "抒情文", "日記", "記人", "閱讀報告",
    "記事", "描寫景物", "說明道理", "遊記", "廣告", "記物", "通記", "寓言故事"
  ],
  
  languageUsage: [
    {
      title: "反義詞",
      description: "學習反義詞的用法，掌握詞語的對立關係",
      sampleQuestions: [
        {
          question: "選擇正確的反義詞：『大』的反義詞是（ ）",
          answer: "小",
          explanation: "『大』和『小』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『高』的反義詞是（ ）",
          answer: "矮",
          explanation: "『高』和『矮』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『長』的反義詞是（ ）",
          answer: "短",
          explanation: "『長』和『短』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『寬』的反義詞是（ ）",
          answer: "窄",
          explanation: "『寬』和『窄』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『厚』的反義詞是（ ）",
          answer: "薄",
          explanation: "『厚』和『薄』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『重』的反義詞是（ ）",
          answer: "輕",
          explanation: "『重』和『輕』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『快』的反義詞是（ ）",
          answer: "慢",
          explanation: "『快』和『慢』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『新』的反義詞是（ ）",
          answer: "舊",
          explanation: "『新』和『舊』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『好』的反義詞是（ ）",
          answer: "壞",
          explanation: "『好』和『壞』是反義詞。"
        },
        {
          question: "選擇正確的反義詞：『美』的反義詞是（ ）",
          answer: "醜",
          explanation: "『美』和『醜』是反義詞。"
        }
      ]
    },
    {
      title: "多重複句",
      description: "學習多重複句的結構，掌握複雜句子的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的連接詞：我喜歡讀書，（ ）我也喜歡畫畫，（ ）我也喜歡唱歌。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小明很聰明，（ ）他很勤奮，（ ）他很努力。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：我喜歡紅色，（ ）我也喜歡藍色，（ ）我也喜歡綠色。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：這本書很有趣，（ ）它很有用，（ ）它很實用。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小華很可愛，（ ）她很聰明，（ ）她很善良。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：我喜歡游泳，（ ）我也喜歡跑步，（ ）我也喜歡騎車。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：他會唱歌，（ ）他會跳舞，（ ）他會彈琴。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：她會畫畫，（ ）她會寫字，（ ）她會做手工。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：我會讀書，（ ）我會寫作，（ ）我會演講。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：他會做飯，（ ）他會洗衣服，（ ）他會打掃。",
          answer: "而且",
          explanation: "『而且』用來連接多個並列的意思。"
        }
      ]
    },
    {
      title: "肯定句和否定句副詞",
      description: "學習肯定句和否定句的結構，掌握副詞的用法",
      sampleQuestions: [
        {
          question: "選擇正確的肯定句：我（ ）讀書",
          answer: "喜歡",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：他（ ）聰明",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：她（ ）可愛",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：這本書（ ）有趣",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的肯定句：這個蘋果（ ）甜",
          answer: "很",
          explanation: "肯定句表示肯定的意思。"
        },
        {
          question: "選擇正確的否定句：我（ ）喜歡讀書",
          answer: "不",
          explanation: "否定句表示否定的意思。"
        },
        {
          question: "選擇正確的否定句：他（ ）聰明",
          answer: "不",
          explanation: "否定句表示否定的意思。"
        },
        {
          question: "選擇正確的否定句：她（ ）可愛",
          answer: "不",
          explanation: "否定句表示否定的意思。"
        },
        {
          question: "選擇正確的否定句：這本書（ ）有趣",
          answer: "不",
          explanation: "否定句表示否定的意思。"
        },
        {
          question: "選擇正確的否定句：這個蘋果（ ）甜",
          answer: "不",
          explanation: "否定句表示否定的意思。"
        }
      ]
    },
    {
      title: "實用文",
      description: "學習實用文的寫作，掌握各種實用文體的格式和內容",
      sampleQuestions: [
        {
          question: "選擇正確的實用文格式：書信開頭應該寫（ ）",
          answer: "稱呼",
          explanation: "書信開頭要寫稱呼。"
        },
        {
          question: "選擇正確的實用文格式：書信結尾應該寫（ ）",
          answer: "敬語",
          explanation: "書信結尾要寫敬語。"
        },
        {
          question: "選擇正確的實用文格式：便條應該寫（ ）",
          answer: "日期",
          explanation: "便條要寫日期。"
        },
        {
          question: "選擇正確的實用文格式：通告應該寫（ ）",
          answer: "標題",
          explanation: "通告要寫標題。"
        },
        {
          question: "選擇正確的實用文格式：日記應該寫（ ）",
          answer: "日期",
          explanation: "日記要寫日期。"
        },
        {
          question: "選擇正確的實用文格式：週記應該寫（ ）",
          answer: "週次",
          explanation: "週記要寫週次。"
        },
        {
          question: "選擇正確的實用文格式：閱讀報告應該寫（ ）",
          answer: "書名",
          explanation: "閱讀報告要寫書名。"
        },
        {
          question: "選擇正確的實用文格式：廣告應該寫（ ）",
          answer: "標語",
          explanation: "廣告要寫標語。"
        },
        {
          question: "選擇正確的實用文格式：遊記應該寫（ ）",
          answer: "地點",
          explanation: "遊記要寫地點。"
        },
        {
          question: "選擇正確的實用文格式：記物應該寫（ ）",
          answer: "物品名稱",
          explanation: "記物要寫物品名稱。"
        }
      ]
    },
    {
      title: "辨別成語的褒貶色彩",
      description: "學習成語的褒貶色彩，掌握成語的感情色彩",
      sampleQuestions: [
        {
          question: "選擇正確的褒貶色彩：『一絲不苟』是（ ）",
          answer: "褒義",
          explanation: "『一絲不苟』是褒義詞，形容做事認真。"
        },
        {
          question: "選擇正確的褒貶色彩：『健步如飛』是（ ）",
          answer: "褒義",
          explanation: "『健步如飛』是褒義詞，形容走路很快。"
        },
        {
          question: "選擇正確的褒貶色彩：『悅耳動聽』是（ ）",
          answer: "褒義",
          explanation: "『悅耳動聽』是褒義詞，形容聲音好聽。"
        },
        {
          question: "選擇正確的褒貶色彩：『栩栩如生』是（ ）",
          answer: "褒義",
          explanation: "『栩栩如生』是褒義詞，形容畫得很逼真。"
        },
        {
          question: "選擇正確的褒貶色彩：『翩翩起舞』是（ ）",
          answer: "褒義",
          explanation: "『翩翩起舞』是褒義詞，形容跳舞優美。"
        },
        {
          question: "選擇正確的褒貶色彩：『工工整整』是（ ）",
          answer: "褒義",
          explanation: "『工工整整』是褒義詞，形容字寫得很整齊。"
        },
        {
          question: "選擇正確的褒貶色彩：『清清楚楚』是（ ）",
          answer: "褒義",
          explanation: "『清清楚楚』是褒義詞，形容說話清楚。"
        },
        {
          question: "選擇正確的褒貶色彩：『仔仔細細』是（ ）",
          answer: "褒義",
          explanation: "『仔仔細細』是褒義詞，形容做事仔細。"
        },
        {
          question: "選擇正確的褒貶色彩：『專心致志』是（ ）",
          answer: "褒義",
          explanation: "『專心致志』是褒義詞，形容專心讀書。"
        },
        {
          question: "選擇正確的褒貶色彩：『勤勤懇懇』是（ ）",
          answer: "褒義",
          explanation: "『勤勤懇懇』是褒義詞，形容工作努力。"
        }
      ]
    }
  ]
};

// Primary 5 Chinese Data - Part 2
export const p5DataPart2 = {
  languageUsage: [
    {
      title: "比喻",
      description: "學習比喻的用法，掌握比喻的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的比喻：她的眼睛像（ ）",
          answer: "星星",
          explanation: "比喻眼睛明亮如星星。"
        },
        {
          question: "選擇正確的比喻：他的笑容像（ ）",
          answer: "陽光",
          explanation: "比喻笑容溫暖如陽光。"
        },
        {
          question: "選擇正確的比喻：她的歌聲像（ ）",
          answer: "黃鶯",
          explanation: "比喻歌聲美妙如黃鶯。"
        },
        {
          question: "選擇正確的比喻：他的動作像（ ）",
          answer: "猴子",
          explanation: "比喻動作靈活如猴子。"
        },
        {
          question: "選擇正確的比喻：她的頭髮像（ ）",
          answer: "瀑布",
          explanation: "比喻頭髮柔順如瀑布。"
        },
        {
          question: "選擇正確的比喻：他的皮膚像（ ）",
          answer: "雪",
          explanation: "比喻皮膚白皙如雪。"
        },
        {
          question: "選擇正確的比喻：她的臉蛋像（ ）",
          answer: "蘋果",
          explanation: "比喻臉蛋紅潤如蘋果。"
        },
        {
          question: "選擇正確的比喻：他的聲音像（ ）",
          answer: "雷",
          explanation: "比喻聲音洪亮如雷。"
        },
        {
          question: "選擇正確的比喻：她的腳步像（ ）",
          answer: "貓",
          explanation: "比喻腳步輕盈如貓。"
        },
        {
          question: "選擇正確的比喻：他的力氣像（ ）",
          answer: "牛",
          explanation: "比喻力氣大如牛。"
        }
      ]
    },
    {
      title: "多音字",
      description: "學習多音字的用法，掌握多音字的不同讀音和意義",
      sampleQuestions: [
        {
          question: "選擇正確的讀音：『長』在『長大』中讀（ ）",
          answer: "zhǎng",
          explanation: "『長』在這裡讀zhǎng，表示成長。"
        },
        {
          question: "選擇正確的讀音：『長』在『長度』中讀（ ）",
          answer: "cháng",
          explanation: "『長』在這裡讀cháng，表示長度。"
        },
        {
          question: "選擇正確的讀音：『行』在『行走』中讀（ ）",
          answer: "xíng",
          explanation: "『行』在這裡讀xíng，表示行走。"
        },
        {
          question: "選擇正確的讀音：『行』在『銀行』中讀（ ）",
          answer: "háng",
          explanation: "『行』在這裡讀háng，表示行業。"
        },
        {
          question: "選擇正確的讀音：『樂』在『快樂』中讀（ ）",
          answer: "lè",
          explanation: "『樂』在這裡讀lè，表示快樂。"
        },
        {
          question: "選擇正確的讀音：『樂』在『音樂』中讀（ ）",
          answer: "yuè",
          explanation: "『樂』在這裡讀yuè，表示音樂。"
        },
        {
          question: "選擇正確的讀音：『好』在『好人』中讀（ ）",
          answer: "hǎo",
          explanation: "『好』在這裡讀hǎo，表示好的。"
        },
        {
          question: "選擇正確的讀音：『好』在『愛好』中讀（ ）",
          answer: "hào",
          explanation: "『好』在這裡讀hào，表示愛好。"
        },
        {
          question: "選擇正確的讀音：『重』在『重量』中讀（ ）",
          answer: "zhòng",
          explanation: "『重』在這裡讀zhòng，表示重量。"
        },
        {
          question: "選擇正確的讀音：『重』在『重複』中讀（ ）",
          answer: "chóng",
          explanation: "『重』在這裡讀chóng，表示重複。"
        }
      ]
    },
    {
      title: "近義詞",
      description: "學習近義詞的區別，掌握詞語的細微差異",
      sampleQuestions: [
        {
          question: "選擇正確的近義詞：『美麗』的近義詞是（ ）",
          answer: "漂亮",
          explanation: "『美麗』和『漂亮』都是形容外表好看的詞語。"
        },
        {
          question: "選擇正確的近義詞：『快樂』的近義詞是（ ）",
          answer: "開心",
          explanation: "『快樂』和『開心』都是形容心情愉快的詞語。"
        },
        {
          question: "選擇正確的近義詞：『聰明』的近義詞是（ ）",
          answer: "智慧",
          explanation: "『聰明』和『智慧』都是形容智力高的詞語。"
        },
        {
          question: "選擇正確的近義詞：『勤奮』的近義詞是（ ）",
          answer: "努力",
          explanation: "『勤奮』和『努力』都是形容工作認真的詞語。"
        },
        {
          question: "選擇正確的近義詞：『安靜』的近義詞是（ ）",
          answer: "寧靜",
          explanation: "『安靜』和『寧靜』都是形容環境安靜的詞語。"
        },
        {
          question: "選擇正確的近義詞：『大』的近義詞是（ ）",
          answer: "巨大",
          explanation: "『大』和『巨大』都是形容體積大的詞語。"
        },
        {
          question: "選擇正確的近義詞：『小』的近義詞是（ ）",
          answer: "微小",
          explanation: "『小』和『微小』都是形容體積小的詞語。"
        },
        {
          question: "選擇正確的近義詞：『高』的近義詞是（ ）",
          answer: "高大",
          explanation: "『高』和『高大』都是形容高度高的詞語。"
        },
        {
          question: "選擇正確的近義詞：『低』的近義詞是（ ）",
          answer: "矮小",
          explanation: "『低』和『矮小』都是形容高度低的詞語。"
        },
        {
          question: "選擇正確的近義詞：『新』的近義詞是（ ）",
          answer: "嶄新",
          explanation: "『新』和『嶄新』都是形容新的詞語。"
        }
      ]
    },
    {
      title: "排比/句義辨析",
      description: "學習排比的用法，掌握句義的辨析方法",
      sampleQuestions: [
        {
          question: "選擇正確的排比句：我喜歡讀書，（ ）我喜歡畫畫，（ ）我喜歡唱歌。",
          answer: "我喜歡",
          explanation: "這是排比句，重複使用相同的句式。"
        },
        {
          question: "選擇正確的排比句：他會唱歌，（ ）他會跳舞，（ ）他會彈琴。",
          answer: "他會",
          explanation: "這是排比句，重複使用相同的句式。"
        },
        {
          question: "選擇正確的排比句：她會畫畫，（ ）她會寫字，（ ）她會做手工。",
          answer: "她會",
          explanation: "這是排比句，重複使用相同的句式。"
        },
        {
          question: "選擇正確的排比句：我會讀書，（ ）我會寫作，（ ）我會演講。",
          answer: "我會",
          explanation: "這是排比句，重複使用相同的句式。"
        },
        {
          question: "選擇正確的排比句：他會做飯，（ ）他會洗衣服，（ ）他會打掃。",
          answer: "他會",
          explanation: "這是排比句，重複使用相同的句式。"
        },
        {
          question: "選擇正確的句義：『我喜歡讀書』的意思是（ ）",
          answer: "我愛讀書",
          explanation: "這句話表示我愛讀書。"
        },
        {
          question: "選擇正確的句義：『他會唱歌』的意思是（ ）",
          answer: "他有唱歌的能力",
          explanation: "這句話表示他有唱歌的能力。"
        },
        {
          question: "選擇正確的句義：『她很聰明』的意思是（ ）",
          answer: "她智力很高",
          explanation: "這句話表示她智力很高。"
        },
        {
          question: "選擇正確的句義：『這本書很有趣』的意思是（ ）",
          answer: "這本書很有意思",
          explanation: "這句話表示這本書很有意思。"
        },
        {
          question: "選擇正確的句義：『這個蘋果很甜』的意思是（ ）",
          answer: "這個蘋果味道很甜",
          explanation: "這句話表示這個蘋果味道很甜。"
        }
      ]
    },
    {
      title: "對偶",
      description: "學習對偶的用法，掌握對偶的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的對偶：『春眠不覺曉』的對偶句是（ ）",
          answer: "處處聞啼鳥",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『白日依山盡』的對偶句是（ ）",
          answer: "黃河入海流",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『遠看山有色』的對偶句是（ ）",
          answer: "近聽水無聲",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『千山鳥飛絕』的對偶句是（ ）",
          answer: "萬徑人蹤滅",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『孤舟蓑笠翁』的對偶句是（ ）",
          answer: "獨釣寒江雪",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『小荷才露尖尖角』的對偶句是（ ）",
          answer: "早有蜻蜓立上頭",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『停車坐愛楓林晚』的對偶句是（ ）",
          answer: "霜葉紅於二月花",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『兩個黃鸝鳴翠柳』的對偶句是（ ）",
          answer: "一行白鷺上青天",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『床前明月光』的對偶句是（ ）",
          answer: "疑是地上霜",
          explanation: "這是對偶句，字數相等，結構相同。"
        },
        {
          question: "選擇正確的對偶：『鋤禾日當午』的對偶句是（ ）",
          answer: "汗滴禾下土",
          explanation: "這是對偶句，字數相等，結構相同。"
        }
      ]
    }
  ]
}; 